import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PentagonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pentagon"}/>
}
